import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: ['success', 'danger'],
  modifiers: ['light', 'dark']
}

export default function Alert(props) {
  const {
    children,
    onClick,
    isOpen = true,
    success = false,
    danger = false,
    light = false,
    dark = false
  } = props

  const [state, setState] = React.useState(isOpen)

  const handleClick = (e) => {
    const newState = !state
    setState(newState)
    onClick && onClick(e)

  }

  React.useEffect(() => {
    setState(isOpen)
  }, [isOpen])


  return (
    <div
      className={`${resolveProps(props, config, 'Alert')}
      ${state ? 'mdn-isOpen' : ''}`}
      aria-hidden={state ? 'false' : 'true'}
      tabIndex={0}
    >
      <div className="mdn-Alert-content">
        <p className="mdn-Text mdn-Text--body">{children}</p>
      </div>
      <button
        role="button"
        type='button'
        className="mdn-Alert-close mdn-Button mdn-Button--icon mdn-Button--secondary"
        onClick={(e) => handleClick(e)}
        aria-label="Button close alert"
      >
        <span className="mdn-Icon-fechar mdn-Icon--sm"></span>
      </button>
    </div>
  )
}

Alert.propTypes = {
  children: PropTypes.node.isRequired
}
